import React from 'react'

export default React.memo(props => {
    return <div>Document</div>
})


// WEBPACK FOOTER //
// ./app/App/Module/Pedagogie/Page/Document/index.js